import { type ComponentPropsWithRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FieldProps = ComponentPropsWithRef<'div'>;

export const Field = memo(
  forwardRef<HTMLDivElement, FieldProps>(({ children, className, ...restOfProps }, forwardedRef) => {
    return (
      <div className={cn('relative flex flex-col gap-2', className)} ref={forwardedRef} {...restOfProps}>
        {children}
      </div>
    );
  }),
);

Field.displayName = 'Field';
